import { gql } from "@apollo/client";

export const InstalledBaseNode = gql`
    query InstalledBaseNode($id: ID!) {
        installedBaseNode (id: $id){
            id
            key
            title
            isStarred
            nodeType {
                id
                key
                name
            }
            owner {
                id
                industryType
            }
            parentNode {
                id
            }
            pathNodes {
                id
                nodeType {
                    id
                    key
                }
            }
            access {
                id
                read
                write
                delete
            }
            keyPath
            system {
                id
                systemType
            }
            nodeRules {
                childRules {
                    nodeTypeKey
                    currentNodeCount
                    limits {
                        min
                        max
                    }
                }
            }
            assetLocation {
                id
                isInstalled
                iotConnection {
                    id
                }
                asset {
                    id
                }
            }
        }
    }
`;
